import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-nouvelles',
  templateUrl: './nouvelles.component.html',
  styleUrls: ['./nouvelles.component.scss']
})
export class NouvellesComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public currentLang: string;
  public nbNouvelles: number;
  public listeNouvelles: any[];

  constructor(private route: ActivatedRoute, private translateService: TranslateService) {
    this.listeNouvelles = this.route.snapshot.data.nouvelles;
    this.nbNouvelles = this.listeNouvelles.length || 0;
    this.currentLang = this.translateService.currentLang;
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {
    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​

}
